import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import { GET_MEMBER_WORKOUT_SUMMARY, GET_MEMBER_WORKOUT_CALENDAR } from '@Apis/apiPath';

const useMemberWorkoutApi = () => {
    const Axios = useAxios();

    const getMemberWorkoutSummaryApi = useCallback(
        async (isLoadingVisible = true) => {
            const resp = await Axios.get(GET_MEMBER_WORKOUT_SUMMARY, {}, { isLoadingVisible });
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getMemberWorkoutCalendarApi = useCallback(
        async (params, isLoadingVisible = true) => {
            const resp = await Axios.get(GET_MEMBER_WORKOUT_CALENDAR, params, { isLoadingVisible });
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    return {
        getMemberWorkoutSummaryApi,
        getMemberWorkoutCalendarApi,
    }
};

export default useMemberWorkoutApi;